module.exports = __webpack_public_path__ + "static/media/bn_website_copy.26bfe493.png";